/**
 * Build a deterministic namespaced draft-storage key.
 */
export const buildDraftStorageKey = (...parts: Array<string | number | null | undefined>): string =>
  parts
    .map((part) => {
      if (part == null || part === "") {
        return "none";
      }
      return String(part).trim().replace(/[:\s]+/g, "_");
    })
    .join(":");
